import type {
  AcLineSegment,
  PowerTransformerEnd,
  Terminal,
  Switch,
  FunctionalGridElement,
  FunctionalGridEdge,
  FunctionalGridElementTypes
} from './FunctionalGrid';

export class Edge {
  static fromAcLineSegment(acLineSegment: AcLineSegment): EdgeType {
    return {
      objectId: acLineSegment.objectId,
      type: 'AcLineSegment',
      connectivity1: acLineSegment.connectivity1,
      connectivity2: acLineSegment.connectivity2
    };
  }

  static fromPowerTransformerEnd(
    powerTransformerEnd: PowerTransformerEnd
  ): EdgeType {
    return {
      objectId: powerTransformerEnd.objectId,
      type: 'PowerTransformerEnd',
      connectivity1: powerTransformerEnd.connectivity1,
      connectivity2: powerTransformerEnd.connectivity2
    };
  }

  static fromTerminal(terminal: Terminal): EdgeType {
    return {
      objectId: terminal.objectId,
      type: 'Terminal',
      connectivity1: terminal.connectivity1,
      connectivity2: terminal.connectivity2
    };
  }

  static fromSwitch(switchElement: Switch): EdgeType {
    return {
      objectId: switchElement.objectId,
      type: 'Switch',
      connectivity1: switchElement.connectivity1,
      connectivity2: switchElement.connectivity2
    };
  }
}

export type EdgeType = FunctionalGridElement &
  FunctionalGridEdge & { type: FunctionalGridElementTypes };
